import { useCallback, useContext } from 'react'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import AuthContext from '../../context/authContext'
import { canReadCapability, getRpcAccess } from './rpcAuthorization'

export const useReadAccess = (...capabilities: CAPABILITY[]): boolean => {
  const canRead = useReadAccessChecker()
  return capabilities.every(canRead)
}

export const useReadAccessChecker = (): ((
  capability: CAPABILITY,
) => boolean) => {
  const { authCtx } = useContext(AuthContext)
  return useCallback(
    (cap) => !authCtx.isAuthLoading && canReadCapability(authCtx, cap),
    [authCtx],
  )
}

export const useRpcReadAccess = (
  method: unknown,
  request?: unknown,
): boolean => {
  const { authCtx } = useContext(AuthContext)
  return getRpcAccess(method, authCtx, request) === 'allowed'
}
